import { injectable } from "inversify";
import { TableRepo } from "../table.repo";
import { FactoryBillingModel } from "@/core/models/factory-billing.model";



@injectable()
export class FactoryBillingRepo extends TableRepo<FactoryBillingModel> {
    constructor() {
        super("/api/factoryBilling");
    }
    async getDetail(id: string): Promise<FactoryBillingModel> {
        try {
            const response = await this.apiRepo.get<FactoryBillingModel>(`${this.basepath}/detail`, {id});
            if (response?.code === '00') {
                return response.result
            };
        } catch (err) {
            console.log(err);
        }
        return {} as FactoryBillingModel;
    }
    async GetByWaterFactory(): Promise<FactoryBillingModel> {
        try {
            const response = await this.apiRepo.get<FactoryBillingModel>(`${this.basepath}/get-by-water-factory`);
            if (response?.code === '00') {
                return response.result
            };
        } catch (err) {
            console.log(err);
        }
        return {} as FactoryBillingModel;
    }


    
}